import PropTypes from 'prop-types';
import advertsStrings from 'modules/adverts/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './AdvertsFilter.style';

const AdvertsFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={advertsStrings.advertsFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
AdvertsFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default AdvertsFilter;
